import { Flex } from '@mantine/core';
import { StepCard } from 'src/UI/generate-flow/StepCard';
import { SettingsRow } from 'src/suitability-report/SettingsRow';
import { DataExportStepProps } from '../types';

export function DataExportGenerateStep({ data, setData }: DataExportStepProps) {
  return (
    <Flex direction="column" h="100%" mih={0}>
      <StepCard title="Configure data export options">
        <Flex direction="column" gap="sm">
          <Flex
            direction="column"
            gap="xs"
            p="md"
            bd="1px solid var(--mantine-color-brand-6)"
            style={{ borderRadius: 12 }}
            bg="white"
          >
            <SettingsRow
              title="Show sensitive fields"
              description="Whether to include sensitive fields such as addiction history, mental health considerations, and caring responsibilities in the data export."
              checked={data.includeSensitiveFields}
              onChange={checked =>
                setData(prev => ({
                  ...prev,
                  includeSensitiveFields: checked,
                }))
              }
            />
          </Flex>
          <Flex
            direction="column"
            gap="xs"
            p="md"
            bd="1px solid var(--mantine-color-brand-6)"
            style={{ borderRadius: 12 }}
            bg="white"
          >
            <SettingsRow
              title="Export as Excel (.xlsx)"
              description="Export as an Excel spreadsheet instead of a Word document (.docx)."
              checked={data.exportFormat === 'EXCEL'}
              onChange={checked =>
                setData(prev => ({
                  ...prev,
                  exportFormat: checked ? 'EXCEL' : 'DOCX',
                }))
              }
            />
          </Flex>
        </Flex>
      </StepCard>
    </Flex>
  );
}
